import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { MeasurementStatusUpdate } from "../../shared/interfaces/MeasurementStatusUpdate";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useResultMeasurementStatusUpdate(callbacks?: QueryCallbacks<number>) {
  const { resultsApis } = useContext(ApiContext);

  return useMutation(
    async (params: MeasurementStatusUpdate) => await resultsApis.updateMeasurementStatus(params),
    callbacks,
  );
}
